import { all, takeEvery, call, select, put } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { dashboardSetIgnoredMovies } from '../../actions'
import createApiCall from '../../apis/wpApi/endpoints'
import authUser from '../../apis/wpApi/authUser'
import getData from '../../functions/getData'
import { PROGRAM_CLI_MOVIES_ITEMS } from '../../constants/state'

const changelogReadCall = (data) => createApiCall({
    url:          `${pmkinoClientVars.siteURL}/wp-json/pmkino/v1/dashboard/changelog-read`,
    method:       'POST',
    data,
    headerParams: { token: authUser.getToken() },
})

const ignoredMoviesCall = (ids) => createApiCall({
    url:          `${pmkinoClientVars.siteURL}/wp-json/pmkino/v1/dashboard/ignored-movies`,
    method:       'POST',
    data:         { ids },
    headerParams: { token: authUser.getToken() },
})

function* markReadCall(version) {
    yield call(changelogReadCall, { version })
}

function* markAllReadCall(versions) {
    yield call(changelogReadCall, { all: true, versions })
}

function* watchMarkRead() {
    yield takeEvery(actionTypes.CHANGELOG_MARK_READ, function*(action) {
        try { yield call(markReadCall, action.version) } catch(e) {}
    })
}

function* watchMarkAllRead() {
    yield takeEvery(actionTypes.CHANGELOG_MARK_ALL_READ, function*(action) {
        try { yield call(markAllReadCall, action.versions) } catch(e) {}
    })
}

function* watchIgnoreMovie() {
    yield takeEvery([actionTypes.DASHBOARD_IGNORE_MOVIE, actionTypes.DASHBOARD_UNIGNORE_MOVIE], function*() {
        try {
            const ids = yield select(state => {
                const list = state.getIn(['ui', 'dashboard', 'ignoredMovieIds'])
                return list ? list.toArray() : []
            })
            yield call(ignoredMoviesCall, ids)
        } catch(e) {}
    })
}

function* watchCleanupIgnored() {
    yield takeEvery(actionTypes.LOAD_ALL_DATA_SUCCESS, function*() {
        try {
            const { ignoredIds, moviesMap } = yield select(state => ({
                ignoredIds: state.getIn(['ui', 'dashboard', 'ignoredMovieIds']),
                moviesMap:  getData(state, PROGRAM_CLI_MOVIES_ITEMS),
            }))
            if (!ignoredIds || !moviesMap || ignoredIds.size === 0) return
            const hasStale = ignoredIds.some(id => !moviesMap.has(String(id)))
            if (!hasStale) return
            const cleanIds = ignoredIds.filter(id => moviesMap.has(String(id))).toArray()
            yield put(dashboardSetIgnoredMovies(cleanIds))
            yield call(ignoredMoviesCall, cleanIds)
        } catch(e) {}
    })
}

export default function* dashboardSaga() {
    yield all([
        watchMarkRead(),
        watchMarkAllRead(),
        watchIgnoreMovie(),
        watchCleanupIgnored(),
    ])
}
